import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {
  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: '',
    titleIcon: '',
  };

  List: any[] = [
    { title: 'PEOPLE_GENERATED_SOFTWARE', btnText: '', image: '../../../../assets/images/se-icons/monitor.png', desc: 'PEOPLE_GENERATED_SOFTWARE_DESCRIPTION' },
    { title: 'ADMINISTRATION_BY_EXPERTS', btnText: '', image: '../../../../assets/images/se-icons/platforms2.png', desc: 'ADMINISTRATION_BY_EXPERTS_DESCRIPTION' },
    { title: 'AI_GENERATED_SOFTWARE', btnText: '', image: '../../../../assets/images/se-icons/ai-programming.png', desc: 'AI_GENERATED_SOFTWARE_DESC' },
    { title: 'BUSINESS_PROCESSES', btnText: '', image: '../../../../assets/images/se-icons/cloud-it-department.png', desc: 'CLOUD_IT_DEPARTMENT_DESCRIPTION' },
    { title: 'CLOUD_DB', btnText: '', image: '../../../../assets/images/se-icons/cloud-database.png', desc: 'CLUSTER_TEXT' },
    { title: 'AI_CHAT_BOT', btnText: '', image: '../../../../assets/images/se-icons/sync-api.png', desc: 'CHAT_SYSTEM_DESCRIPTION' },
    { title: 'BUSINESS_LOGIC_INTERFACE', btnText: '', image: '../../../../assets/images/se-icons/designer-web.png', desc: 'BUSINESS_LOGIC_DESCRIPTION' },
    { title: 'OUR_APPLICATIONS', btnText: '', image: '../../../../assets/images/se-icons/devtools.png', desc: 'TOOLS_DESCRIPTION' }
  ]
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

}
